import Login from '../auth/login';

import OperationDashboard from '../dashboard/operationsdashboard';
import Recap from '../dashboard/recap';
import SuperVisorView from '../dashboard/supervisorview';
import MainDashboard from '../dashboards/maindashboard';
import SuperAdminDashboard from '../dashboards/supervisordashbordfiltrs';
import Weekly from '../dashboards/weekly';
import Devicehome from '../Devices/Devicehome';
import Docshome from '../Docs/Docshome';
import FormsDashboard from '../forms/FormsDashboard';
import Profilepage from '../header/Profilepage';
import Reportshome from '../Reports/Reportshome';
import Safetyhome from '../Safety/Safetyhome';
import Supporthome from '../Support/Supporthome';
import ViewTimeSheet from '../timesheets/viewtimesheet';
import Users from '../Users/Users';
import  DriverInformation from '../forms/WeeklyDforms/Driverinformation'
import BBSObservationForm from '../forms/BSSforms/BBSO1Form';
import SafetyHomeInfoForm from '../forms/SafetyHealthforms/SafetyInformation';
import ReportAuthorizer from '../Reports/authorizer';
import AccidentAndInvesticationForm from '../forms/accidentinvestigation.jsx/accidentinvestigationform';
import TrailerInspectionForm from '../forms/TrailerForms/TrailerInspectionForm';
import AttendanceDashboard from '../analyticsdashboards/attendancedashboard/attendancedashboard';
import SafetyAnalytics from '../analyticsdashboards/safetyanalytics/safetyanalytics';
import JobAnalytics from '../analyticsdashboards/jobanalytics/jobanalytics';
import OnBoarding from '../onBoarding/onBoarding';
import OnBoardingView from '../onBoarding/screens/onBoardview';
import MerdgeDashboard from '../forms/mergedashboards/mergedashboad';
import Generalusers from '../generalUsers/generalusers';
import Logs from '../logs/logs';
import OtpLogs from '../logs/otplogs';
import ActivityTrail from '../logs/activitytrail';
import AuditLog from '../logs/auditlog';
import ManualDoc from '../manuals/mannual';
import Reenroll from '../onBoarding/reenroll';
import PublicManualDoc from '../manuals/publicmanualdoc';
import ManualWrapper from '../Docs/manualwrapper';
import SubcontractorForm from '../forms/SubcontractorForms/SubcontractorForm';
import SubcontractorLogin from '../forms/SubcontractorForms/SubcontractorLogin';
import SubcontractorRetrieve from '../forms/SubcontractorForms/SubcontractorRetrieve';
import SubcontractorDashboard from '../forms/SubcontractorForms/SubcontractorDashboard';
import { SUBCONTRACTOR_ROUTES } from '../forms/SubcontractorForms/routes';
import DraftsDashboard from '../forms/DraftsDashboard';
import AiVectorChat from '../global/AiVectorChat';



const routes = [
  { path: "/", component: <Login />, showHeader: false, access:['All'] },
  { path: "/home", component: <AttendanceDashboard />, showHeader: true ,access:['All']  },
  { path: "/dashboard", component: <SuperVisorView />, showHeader: true ,access:['All'] },
  { path: "/timesheet", component: <ViewTimeSheet />, showHeader: true ,access:['All']  },
  { path: "/recap", component: <Recap/>, showHeader: true ,access:['All'] },
  { path: "/users", component: <Users />, showHeader: true ,access:['Admin','Project Manager'] },
  { path: "/report", component: <Reportshome />, showHeader: true,access:['Admin','Project Manager']  },
  { path: "/devices", component: <Devicehome />, showHeader: true,access:['Admin','Project Manager']  },
  { path: "/support", component: <Supporthome />, showHeader: true,access:['Admin','Project Manager']  },
  { path: "/safety", component: <Safetyhome />, showHeader: true,access:['Admin','Project Manager']  },
   { path: "/onboarding", component: <OnBoarding />, showHeader: true,access:['Admin','Supervisor']  },
    { path: "/enroll", component: <Reenroll />, showHeader: true,access:['All']  },
      { path: "/register", component: < Generalusers />, showHeader: true,access:['Admin']  },
      { path: "/view-onboarding", component: <OnBoardingView />, showHeader: true,access:['Admin','Supervisor']  },
          { path: "/doc", component: <ManualDoc />, showHeader: true,access:['All']  },
           { path: "/logs", component: <Logs />, showHeader: true,access:['All']  },
           { path: "/otp-logs", component: <OtpLogs />, showHeader: true,access:['Admin']  },
           { path: "/activity-trail", component: <ActivityTrail />, showHeader: true,access:['Admin']  },
           { path: "/audit-log", component: <AuditLog />, showHeader: true,access:['Admin']  },
  { path: "/profile", component: <Profilepage />, showHeader: true,access:['All']  },
  { path: "/docs", component: <Docshome />, showHeader: true,access:['All']  },
   { path: "/manual-dashboard", component: <ManualWrapper />, showHeader: true,access:['All']  },
  { path: "/forms", component: <FormsDashboard />, showHeader: true, access:['All']  },
   { path: "/merge-dashboard", component: <MerdgeDashboard/>, showHeader: true, access:['All']  },
  { path: "/driver-form", component: <DriverInformation  />, showHeader: true, access:['All']  },
    { path: "/accident-form", component: <AccidentAndInvesticationForm />, showHeader: true, access:['All']  },
  { path: "/bbs-form", component: <BBSObservationForm  />, showHeader: true, access:['All']  },
  { path: "/safety-form", component: <SafetyHomeInfoForm  />, showHeader: true, access:['All']  },
  { path: "/trailer-form", component: <TrailerInspectionForm />, showHeader: true, access:['All'] },
  { path: SUBCONTRACTOR_ROUTES.login, component: <SubcontractorLogin />, showHeader: false, access:['All'] },
  { path: SUBCONTRACTOR_ROUTES.retrieve, component: <SubcontractorRetrieve />, showHeader: false, access:['All'] },
  { path: SUBCONTRACTOR_ROUTES.form, component: <SubcontractorForm />, showHeader: false, access:['All'] },
  { path: "/subcontractors", component: <SubcontractorDashboard />, showHeader: true, access:['All'] },
  { path: "/drafts", component: <DraftsDashboard />, showHeader: true, access:['All'] },
  {path:'/reports',component:<ReportAuthorizer/> , showHeader:false, access:['ALL']},
  {path:'/safety-analytics',component:<SafetyAnalytics/> , showHeader:true, access:['Admin','Project Manager']},
  {path:'/job-analytics',component:<JobAnalytics/> , showHeader:true, access:['Admin','Project Manager']},
    {path:'/print',component:<PublicManualDoc/> , showHeader:!true, access:['Admin','Project Manager']},
 {path:'/test',component:<>test</> , showHeader:false, access:['ALL']},
  { path: "/ai-vector-test", component: <AiVectorChat />, showHeader: true, access:['Admin'] },
  { path: "/landing", component: <OperationDashboard />, showHeader: true},
  { path: "/main", component: <MainDashboard />, showHeader: true },
  { path: "/supervisor", component: <SuperAdminDashboard />, showHeader: true },
  { path: "/weekly", component: <Weekly />, showHeader: true },
 
];
 
export default routes;